import { blobticService } from '../../Commun/services/blobticService';

export interface GpsAlert {
    id: number;
    uid?: string;
    vehIdf?: number;
    alertType: string;
    alertMessage?: string;
    timestamp: Date;
    status: string;
    lastUpdate?: Date;
    userId?: number;
    // Joined info
    vehRegistration?: string;
    vehBrand?: string;
    vehModel?: string;
    userLib?: string;
}

interface GpsAlertDto {
    ALT_IDF: number;
    ALT_UIDF?: string;
    VEH_IDF?: number;
    ALERT_TYPE: string;
    ALERT_MESSAGE?: string;
    TIMESTAMP: string;
    STATUS: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
    // Joined info
    VEH_REGISTRATION?: string;
    VEH_BRAND?: string;
    VEH_MODEL?: string;
    USR_LIB?: string;
}

const mapDtoToModel = (dto: GpsAlertDto): GpsAlert => ({
    id: dto.ALT_IDF,
    uid: dto.ALT_UIDF,
    vehIdf: dto.VEH_IDF,
    alertType: dto.ALERT_TYPE,
    alertMessage: dto.ALERT_MESSAGE,
    timestamp: new Date(dto.TIMESTAMP),
    status: dto.STATUS,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF,
    vehRegistration: dto.VEH_REGISTRATION,
    vehBrand: dto.VEH_BRAND,
    vehModel: dto.VEH_MODEL,
    userLib: dto.USR_LIB
});

export const gpsAlertsApi = {
    getAlerts: async (params?: any) => {
        let actionParams: any = { OKey: 'Blobtic_Parc,parc_gps_alert,select' };

        if (params) {
            const { searchParams, ...restParams } = params;
            if (searchParams) {
                actionParams = { ...actionParams, ...searchParams };
            }
            actionParams = { ...actionParams, ...restParams };
        }

        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: actionParams
        });

        if (response.success && Array.isArray(response.data)) {
            return response.data.map((item: any) => mapDtoToModel(item));
        }
        return [];
    },

    createAlert: async (data: Partial<GpsAlert>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_gps_alert,insert',
            VEH_IDF: data.vehIdf,
            ALERT_TYPE: data.alertType,
            ALERT_MESSAGE: data.alertMessage,
            TIMESTAMP: data.timestamp?.toISOString() || new Date().toISOString(),
            STATUS: data.status || 'active'
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });

        if (response.success && response.data && (response.data as any[]).length > 0) {
            return mapDtoToModel((response.data as any[])[0]);
        }
        throw new Error(response.message || 'Failed to create alert');
    },

    updateAlert: async (id: number, data: Partial<GpsAlert>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_gps_alert,update',
            ALT_IDF: id,
            STATUS: data.status,
            USER_IDF: data.userId
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });

        if (response.success && response.data && (response.data as any[]).length > 0) {
            return mapDtoToModel((response.data as any[])[0]);
        }
        throw new Error(response.message || 'Failed to update alert');
    },

    deleteAlert: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_gps_alert,delete', ALT_IDF: id }
        });
        return response;
    },

    resolveAlert: async (id: number, currentUserId: number) => {
        return gpsAlertsApi.updateAlert(id, {
            status: 'resolved',
            userId: currentUserId
        });
    }
};
